<app-face (fileReady)="onFileReady($event)"></app-face>
